import Http from '@/utils/http/index';

export default {
  /**
   * 查询公告通知列表
   */
  queryList(params) {
    return Http.get('/merAnnouncement/list', { params });
  },
  /**
   * 查询未读公告通知列表
   */
  queryUnReadList(params) {
    return Http.get('/merAnnouncement/unreadlist', { params });
  },
  /**
   * 查询公告通知详情
   */
  queryDetail(id) {
    return Http.get(`/merAnnouncement/info/${id}`);
  },

  /**
   * 标记已读
   * @param {*} data
   * @returns
   */
  readNotice(data) {
    return Http.post('/merAnnouncement/read', data);
  },
};
